import { observer } from "mobx-react";
import lockImage from "../../assets/lock.png";
import { ExportOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useMobxStores } from "../../stores/stores";
import {
  message,
  Row,
  Tooltip,
  Typography,
  Card,
  Col,
  Modal,
  Button,
} from "antd";
import formatDate from "../../utils/formatDate";
import ItemDetailsActionButton from "./ItemDetailsActionButton";
import { useState } from "react";

const ItemDetailsInfo = ({ setModalVisible }) => {
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);
  const [isDisclaimerForNullOpen, setIsDisclaimerForNullOpen] = useState(false);

  const { marketplaceStore, userStore } = useMobxStores();

  const marketplaceItem = marketplaceStore.marketplaceItem?.item;
  const nft = marketplaceStore?.NFT;

  return (
    <div
      style={{
        paddingLeft: "28px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        marginTop: "16px",
      }}
    >
      {marketplaceItem?.external_link && (
        <Row style={{ gap: "6px" }}>
          <div style={{ width: "16px" }} />
          <Typography
            style={{ fontSize: "16px", fontWeight: "700", color: "#000080" }}
          >
            Website:
          </Typography>
          <Row
            style={{ gap: "6px" }}
            onClick={() =>
              window.open(
                marketplaceItem?.external_link,
                "_blank",
                "noopener,noreferrer",
              )
            }
          >
            <Typography
              style={{ fontSize: "16px", fontWeight: "200", color: "#000080" }}
            >
              {marketplaceItem?.external_link}
            </Typography>
            <ExportOutlined style={{ color: "#000080" }} />
          </Row>
        </Row>
      )}
      {nft?.license && (
        <Row style={{ gap: "6px" }}>
          <div style={{ width: "16px" }} />
          <Typography
            style={{ fontSize: "16px", fontWeight: "700", color: "#000080" }}
          >
            License:
          </Typography>{" "}
          <Typography
            style={{ fontSize: "16px", fontWeight: "200", color: "#000080" }}
          >
            {
              marketplaceStore.license?.find(
                (license) => license.id === nft.license,
              )?.name
            }
          </Typography>
          <ExportOutlined
            style={{ color: "#000080" }}
            onClick={() =>
              window.open(
                marketplaceStore.license?.find(
                  (license) => license.id === nft.license,
                ).source,
                "_blank",
                "noopener,noreferrer",
              )
            }
          />
        </Row>
      )}
      {nft?.license &&
        marketplaceStore.license?.find((license) => license.id === nft.license)
          ?.name === "EIT Manufacturing Academy" && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <InfoCircleOutlined
                style={{ fontSize: "16px", color: "#2a93d3" }}
              />
              <Typography
                style={{
                  textAlign: "start",
                  fontWeight: "500",
                  color: "#2a93d3",
                }}
                onClick={() => setIsDisclaimerOpen(true)}
              >
                Disclaimer
              </Typography>
            </div>
            <Modal
              open={isDisclaimerOpen}
              footer={[
                <Button
                  type="primary"
                  onClick={() => setIsDisclaimerOpen(false)}
                >
                  I understand
                </Button>,
              ]}
              onCancel={() => setIsDisclaimerOpen(false)}
              className="disclaimer-modal"
              title={
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: "32px",
                    color: "#000080",
                    backgroundColor: "#d9d9d9",
                    marginBottom: "20px",
                  }}
                >
                  Disclaimer
                </div>
              }
              width={"1000px"}
            >
              {
                marketplaceStore.license.find(
                  (license) => license.name === "EIT Manufacturing Academy",
                )?.description
              }
            </Modal>
          </>
        )}

      {marketplaceItem?.type === "MOOC" && marketplaceItem?.nft === null && (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <InfoCircleOutlined
              style={{ fontSize: "16px", color: "#2a93d3" }}
            />
            <Typography
              style={{
                textAlign: "start",
                fontWeight: "500",
                color: "#2a93d3",
              }}
              onClick={() => setIsDisclaimerForNullOpen(true)}
            >
              Disclaimer
            </Typography>
          </div>
          <Modal
            open={isDisclaimerForNullOpen}
            footer={[
              <Button
                type="primary"
                onClick={() => setIsDisclaimerForNullOpen(false)}
              >
                I understand
              </Button>,
            ]}
            onCancel={() => setIsDisclaimerForNullOpen(false)}
            className="disclaimer-modal"
            title={
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "32px",
                  color: "#000080",
                  backgroundColor: "#d9d9d9",
                  marginBottom: "20px",
                }}
              >
                Disclaimer
              </div>
            }
            width={"1000px"}
          >
            This course is hosted on the EIT Manufacturing South Academy. To
            access it, users must first register on the EIT Manufacturing South
            Academy platform at{" "}
            <Typography.Link
              href="https://eitmanufacturing.skillsincloud.com/users/sign_up"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://eitmanufacturing.skillsincloud.com/users/sign_up
            </Typography.Link>
          </Modal>
        </>
      )}
      {marketplaceItem?.created && (
        <Row style={{ gap: "6px" }}>
          <div style={{ width: "16px" }} />
          <Typography
            style={{ fontSize: "16px", fontWeight: "800", color: "#000080" }}
          >
            Created at:
          </Typography>
          <Typography
            style={{ fontSize: "16px", fontWeight: "200", color: "#000080" }}
          >
            {formatDate(marketplaceItem.created)}
          </Typography>
        </Row>
      )}
      {nft && nft.supply > 1 && (
        <Row style={{ gap: "6px" }}>
          <div style={{ width: "16px" }} />
          <Typography
            style={{ fontSize: "16px", fontWeight: "800", color: "#000080" }}
          >
            Editions:
          </Typography>
          <Typography
            style={{ fontSize: "16px", fontWeight: "200", color: "#000080" }}
          >
            {nft.supply}
          </Typography>
        </Row>
      )}
      {nft && nft.royalty_value && (
        <Row style={{ gap: "6px" }}>
          <Tooltip title="The percentage from the resells to be returned to the original creator.">
            <InfoCircleOutlined
              style={{ fontSize: "16px", color: "#000080" }}
            />
          </Tooltip>
          <Typography
            style={{ fontSize: "16px", fontWeight: "800", color: "#000080" }}
          >
            Royalty:
          </Typography>
          <Typography
            style={{ fontSize: "16px", fontWeight: "200", color: "#000080" }}
          >
            {nft.royalty_value}%
          </Typography>
        </Row>
      )}
      {marketplaceStore.marketplaceItem?.events?.[0]?.etherscan && (
        <div
          style={{
            display: "flex",
            gap: "8px",
          }}
        >
          <Tooltip title="Explore the NFT's details on the Ethereum blockchain">
            <InfoCircleOutlined
              style={{ fontSize: "16px", color: "#000080" }}
            />
          </Tooltip>
          <div
            style={{
              cursor: "pointer",
              width: "fit-content",
              display: "flex",
              gap: "8px",
            }}
          >
            <Typography.Link
              href={`${marketplaceStore.marketplaceItem?.events?.[0]?.etherscan}`}
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#000080",
                alignItems: "center",
              }}
            >
              View on Etherscan
            </Typography.Link>
            <ExportOutlined
              style={{ color: "#000080" }}
              onClick={() =>
                window.open(
                  marketplaceStore.marketplaceItem?.events?.[0]?.etherscan,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            />
          </div>
        </div>
      )}
      {marketplaceStore.unlockable_source ? (
        <Card
          style={{
            width: "480px",
            backgroundColor: "transparent",
          }}
        >
          <Row>
            <Col>
              <Typography.Text
                style={{
                  fontSize: "16px",
                  fontWeight: "800",
                  color: "#000080",
                }}
              >
                Find your content
              </Typography.Text>

              <Typography.Link
                href={marketplaceStore.unlockable_source}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: "500" }}
              >
                {" "}
                here
              </Typography.Link>
            </Col>
          </Row>
          <Row>
            <Typography.Text
              style={{ fontSize: "16px", fontWeight: "800", color: "#000080" }}
            >
              Unlock Content:&nbsp;
            </Typography.Text>

            {marketplaceStore.unlockable_content_text}
          </Row>
        </Card>
      ) : (
        marketplaceItem?.has_unlockable_content && (
          <div
            style={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Tooltip title="Unlock item content">
              <InfoCircleOutlined
                style={{ fontSize: "16px", color: "#000080" }}
              />
            </Tooltip>

            <div
              style={{
                width: "160px",
                height: "32px",
                backgroundColor: "#000080",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                borderRadius: "10px",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                cursor: "pointer",
              }}
              onClick={() => {
                if (
                  marketplaceItem.owner === userStore.user?.id ||
                  marketplaceStore.ownership.find(
                    (o) => o.owner === userStore.user?.id,
                  )
                ) {
                  marketplaceStore.UnlockContent(marketplaceItem.nft);
                } else {
                  message.error("You must be the owner to unlock the content.");
                }
              }}
            >
              <img
                alt="unlock"
                src={lockImage}
                style={{ width: "10px", height: "12px" }}
              />
              <span style={{ fontSize: "16px" }}>Unlock content</span>
            </div>
          </div>
        )
      )}
      <ItemDetailsActionButton setModalVisible={setModalVisible} />
    </div>
  );
};

export default observer(ItemDetailsInfo);
